/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import * as vp from 'vopay';
import { FunctionComponent, JSX } from 'react';
import { useHistory } from 'react-router-dom';
import { useNavMenu } from '../../../../providers/NavMenu.provider';
import styles from '../ScheduledTransactions.module.scss';
import { useTranslation } from 'react-i18next';
import { useI18nLabels } from '@/utils/useI18nLabels';

const { Box, SubTitle, Table, Badge, Button } = vp;

type TablePropsHandlers = {
  scheduleDetails: () => vp.TableProps;
};

type KeyValuePair = {
  display: string;
  value: string | JSX.Element;
  visible?: boolean;
};

type TransactionOverviewProps = {
  transactions: { [key: number]: vp.AccountTransferSchedule };
};

type FC = FunctionComponent<TransactionOverviewProps>;

const ScheduledTransactionOverview: FC = (props: TransactionOverviewProps) => {
  const history = useHistory();
  const { transactions } = props;
  const { onSubNavClick } = useNavMenu();
  const transaction = Object.values(transactions)[0];
  const { t } = useTranslation('translations', { keyPrefix: 'ClientAccounts.Schedule.Details.ScheduleDetails' });
  const { frequencyLabelMapper, transferTypeLabelMapper, semiMonthlyDateLabelMapper } = useI18nLabels();

  return (
    <Box flx="col" width="50%" mt="md">
      <SubTitle subTitle={t('title')} />
      <Box mb="lg">
        <div className={styles.tableContainer}>
          <Table {...getTableProps('scheduleDetails')} />
        </div>
      </Box>
    </Box>
  );

  function getTableProps(handler: keyof TablePropsHandlers): vp.TableProps {
    const handlers: TablePropsHandlers = {
      scheduleDetails: () => {
        const accountDetailsPair: KeyValuePair[] = [
          {
            display: t('scheduleID'),
            value: transaction?.ID || '',
            visible: true,
          },
          {
            display: t('DebitorClientAccountID.display'),
            value: (
              <Box jc="fs" ai="center" gap="sm">
                <Box>{transaction?.DebitorClientAccountID || ''}</Box>
                {transaction?.DebitorClientAccountID !== '' &&
                  transaction?.DebitorClientAccountID !== null &&
                  transaction?.DebitorClientAccountID !== undefined && (
                    <Button
                      id="view-client-account-details"
                      label={t('DebitorClientAccountID.viewButton')}
                      width="50px"
                      height="30px"
                      color="secondary"
                      onClick={() => {
                        history.push(`/client-accounts/${transaction?.DebitorClientAccountID}`);
                        onSubNavClick(
                          'clientAccountsList',
                          `/client-accounts/${transaction?.DebitorClientAccountID}`,
                          'Client Accounts List',
                        );
                      }}
                    />
                  )}
              </Box>
            ),
            visible: true,
          },
          {
            display: t('recipientClientAccountID'),
            value: transaction?.RecipientClientAccountID || '',
            visible: transaction && transaction.RecipientClientAccountID !== null,
          },
          {
            display: t('recipientClientAccountIDs'),
            value: createSplitClientAccounts(),
            visible: transaction && transaction.RecipientClientAccountIDSplit !== null,
          },
          {
            display: t('frequency'),
            value: frequencyLabelMapper(transaction?.Frequency),
            visible: transaction?.Frequency !== '',
          },
          {
            display: t('startDate'),
            value: transaction?.ScheduleStartDate,
            visible: true,
          },
          {
            display: t('endDate'),
            value: transaction?.ScheduleEndDate || '',
            visible: transaction?.ScheduleEndDate !== null && transaction?.ScheduleEndDate !== '',
          },
          {
            display: t('status'),
            value: (
              <Badge
                label={vp.capitalizeFirstLetterOfWords(transaction?.Status || '')}
                hasIcon
                color={vp.GetColorStatus(transaction?.Status || '')}
              />
            ),
            visible: true,
          },
          {
            display: t('semiMonthlyType'),
            value: semiMonthlyDateLabelMapper(transaction?.SemiMonthlyFrequencyType),
            visible: transaction?.Frequency === 'semi-monthly',
          },
          {
            display: t('numberOfPayments'),
            value: transaction?.EndingAfterPayments || '',
            visible: transaction?.EndingAfterPayments !== null && transaction?.EndingAfterPayments !== '',
          },
          {
            display: t('description'),
            value: transaction?.Description || '',
            visible: transaction?.Description !== '',
          },
          {
            display: t('type'),
            value: transferTypeLabelMapper(transaction?.TransferType),
            visible: true,
          },
          {
            display: t('amount'),
            value: `$${transaction?.Amount || ''}`,
            visible: true,
          },
          {
            display: t('currency'),
            value: transaction?.Currency || '',
            visible: true,
          },
        ];

        const scheduleDetails: vp.TableProps = {
          name: 'scheduled-details',
          variant: 'pair',
          columns: {
            detailKey: { header: t('title') },
            detailValue: { header: '' },
          },
          rows: accountDetailsPair
            .filter(({ visible }) => visible)
            .map(({ display, value }) => ({
              detailKey: display,
              detailValue: value,
            })),
        };

        return scheduleDetails;
      },
    };

    return handlers[handler]();
  }
  function createSplitClientAccounts(): string {
    const RecipientClientAccountIDSplit = transaction?.RecipientClientAccountIDSplit
      ? JSON.parse(transaction?.RecipientClientAccountIDSplit).map((item: any) => item.ClientAccountID)
      : [];

    return RecipientClientAccountIDSplit.join(', ');
  }
};

export default ScheduledTransactionOverview;
